import {
  InteractiveTree,
  InteractiveTreeNode,
} from '../interactive-tree/InteractiveTree';

export interface IVirtualTree<T, N extends InteractiveTreeNode<T, N>> {
  getVirtualNodes(): VirtualTreeNode<T, N>[];
  getMissingNodes(): VirtualTreeNode<T, N>[];
}

export interface IVirtualTreeNode {
  isVirtual: boolean;
}
export class VirtualTreeNode<T, N extends InteractiveTreeNode<T, N>> extends InteractiveTreeNode<T, N> {
  public isVirtual: boolean = true;
}

export class VirtualTree<T, N extends InteractiveTreeNode<T, N>> extends InteractiveTree<T, N> {
  public getVirtualNodes() {
    return Object.values(this.nodes).filter(node => {
      return node instanceof VirtualTreeNode;
    });
  }
  public getMissingNodes() {
    const nodes = this.getSelectedNodes() as VirtualTreeNode<T, N>[];
    return nodes.filter(node => node.isVirtual);
  }
}
